import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useContext, useState } from 'react';
import { Icon, Button } from 'semantic-ui-react';
import { DEFAULT_ACTIVE_COLOR, DEFAULT_INITIAL_COUNT } from './ReactionIcon.constants';
import { useRecaptcha } from '../../../../../../components/RecaptchaProvider/RecaptchaProvider.hooks';
import useEventPropagation from '../../../../../foundation/hooks/use-event-propagation';
import ReactionPanelContext from '../../ReactionPanel.context';
import './ReactionIcon.css';
var defaultProps = {
  initialCount: DEFAULT_INITIAL_COUNT,
  onClick: function onClick() {
    return null;
  },
  activeColor: DEFAULT_ACTIVE_COLOR,
  displayCount: true
};
export default function ReactionIcon(_ref) {
  var iconId = _ref.iconId,
    initialCount = _ref.initialCount,
    iconName = _ref.iconName,
    onClick = _ref.onClick,
    activeColor = _ref.activeColor,
    action = _ref.action,
    displayCount = _ref.displayCount;
  var _useEventPropagation = useEventPropagation(),
    preventPropagation = _useEventPropagation.preventPropagation;
  var _useContext = useContext(ReactionPanelContext),
    activeId = _useContext.activeId,
    setActiveId = _useContext.setActiveId,
    disabled = _useContext.disabled,
    setDisabled = _useContext.setDisabled;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 2),
    executeRecaptcha = _useRecaptcha2[0],
    recaptchaLoaded = _useRecaptcha2[1];
  var active = iconId === activeId;
  var count = active ? initialCount + 1 : initialCount;
  function handleClick(_x) {
    return _handleClick.apply(this, arguments);
  }
  function _handleClick() {
    _handleClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var token;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            preventPropagation(event, {
              preventDefault: true
            });
            _context.prev = 1;
            setLoading(true);
            setDisabled(true);
            _context.next = 6;
            return executeRecaptcha(action);
          case 6:
            token = _context.sent;
            _context.next = 9;
            return onClick(!active, token);
          case 9:
            _context.next = 11;
            return setActiveId(active ? null : iconId, token);
          case 11:
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            // eslint-disable-next-line no-console
            console.error(_context.t0);
          case 16:
            _context.prev = 16;
            setLoading(false);
            setDisabled(false);
            return _context.finish(16);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 13, 16, 20]]);
    }));
    return _handleClick.apply(this, arguments);
  }
  var iconStyle = active && !loading ? {
    color: activeColor
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "reaction-icon-container"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: true,
    onClick: handleClick,
    loading: loading,
    disabled: disabled || !recaptchaLoaded
  }, /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    style: iconStyle
  }), !!count && displayCount && /*#__PURE__*/React.createElement("span", {
    className: "reaction-icon-label"
  }, count)));
}
ReactionIcon.defaultProps = defaultProps;